// Gradient + filter effects shared between the React renderer and SVG export.
import React from "react";

export function fillRef(el) {
  const f = el.effects?.fill;
  return f && f.kind && f.kind !== "solid" ? `url(#grad-${el.id})` : null;
}

export function filterRef(el) {
  const f = el.effects?.filter;
  return f && f.kind && f.kind !== "none" ? `url(#flt-${el.id})` : null;
}

// ---- React def components (live canvas) ----
function FilterDef({ el, f }) {
  const id = `flt-${el.id}`;
  const s = f.strength ?? 4;
  if (f.kind === "blur") {
    return (
      <filter id={id} x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur stdDeviation={s} />
      </filter>
    );
  }
  if (f.kind === "shadow") {
    return (
      <filter id={id} x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx={f.dx ?? 4} dy={f.dy ?? 4} stdDeviation={s} floodColor={f.color || "#000000"} floodOpacity={f.opacity ?? 0.45} />
      </filter>
    );
  }
  // glow
  return (
    <filter id={id} x="-75%" y="-75%" width="250%" height="250%">
      <feGaussianBlur stdDeviation={s} result="b" />
      <feFlood floodColor={f.color || "#002FA7"} floodOpacity="1" result="c" />
      <feComposite in="c" in2="b" operator="in" result="g" />
      <feMerge>
        <feMergeNode in="g" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  );
}

export function EffectDefs({ el }) {
  const g = el.effects?.fill;
  const f = el.effects?.filter;
  const showG = g && g.kind && g.kind !== "solid";
  const showF = f && f.kind && f.kind !== "none";
  if (!showG && !showF) return null;
  const c1 = el.attrs?.fill && el.attrs.fill !== "none" ? el.attrs.fill : "#002FA7";
  const c2 = g?.to || "#7C3AED";
  return (
    <defs>
      {showG &&
        (g.kind === "radial" ? (
          <radialGradient id={`grad-${el.id}`}>
            <stop offset="0%" stopColor={c1} />
            <stop offset="100%" stopColor={c2} />
          </radialGradient>
        ) : (
          <linearGradient id={`grad-${el.id}`} gradientTransform={`rotate(${g.angle ?? 0})`}>
            <stop offset="0%" stopColor={c1} />
            <stop offset="100%" stopColor={c2} />
          </linearGradient>
        ))}
      {showF && <FilterDef el={el} f={f} />}
    </defs>
  );
}

// ---- String builder (export) ----
export function effectDefsString(el) {
  const g = el.effects?.fill;
  const f = el.effects?.filter;
  const showG = g && g.kind && g.kind !== "solid";
  const showF = f && f.kind && f.kind !== "none";
  if (!showG && !showF) return "";
  const c1 = el.attrs?.fill && el.attrs.fill !== "none" ? el.attrs.fill : "#002FA7";
  const c2 = g?.to || "#7C3AED";
  let out = "";
  if (showG) {
    if (g.kind === "radial") {
      out += `<radialGradient id="grad-${el.id}"><stop offset="0%" stop-color="${c1}"/><stop offset="100%" stop-color="${c2}"/></radialGradient>`;
    } else {
      out += `<linearGradient id="grad-${el.id}" gradientTransform="rotate(${g.angle ?? 0})"><stop offset="0%" stop-color="${c1}"/><stop offset="100%" stop-color="${c2}"/></linearGradient>`;
    }
  }
  if (showF) {
    const s = f.strength ?? 4;
    if (f.kind === "blur") {
      out += `<filter id="flt-${el.id}" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur stdDeviation="${s}"/></filter>`;
    } else if (f.kind === "shadow") {
      out += `<filter id="flt-${el.id}" x="-50%" y="-50%" width="200%" height="200%"><feDropShadow dx="${f.dx ?? 4}" dy="${f.dy ?? 4}" stdDeviation="${s}" flood-color="${f.color || "#000000"}" flood-opacity="${f.opacity ?? 0.45}"/></filter>`;
    } else {
      out += `<filter id="flt-${el.id}" x="-75%" y="-75%" width="250%" height="250%"><feGaussianBlur stdDeviation="${s}" result="b"/><feFlood flood-color="${f.color || "#002FA7"}" flood-opacity="1" result="c"/><feComposite in="c" in2="b" operator="in" result="g"/><feMerge><feMergeNode in="g"/><feMergeNode in="SourceGraphic"/></feMerge></filter>`;
    }
  }
  return out;
}
